import { IAction, IState } from './UseTemplatesListContext';

export type ActionTypes =
  | 'RESET_SELECTED_TEMPLATE'
  | 'SET_FILTER'
  | 'SET_SORTING'
  | 'SET_SELECTED_TEMPLATE'
  | 'SET_SUPPORTED_LANGUAGES';

export function TemplatesListReducer(state: IState, action: IAction) {
  const { payload } = action;
  let newState: IState = null;

  switch (action.type) {
    case 'RESET_SELECTED_TEMPLATE':
      newState = {
        ...state,
        selectedTemplate: null,
      };
      break;
    case 'SET_SELECTED_TEMPLATE':
      newState = {
        ...state,
        selectedTemplate: payload.template,
      };
      break;
    case 'SET_FILTER':
      newState = {
        ...state,
        filterBy: payload.filter,
      };
      break;
    case 'SET_SORTING':
      newState = {
        ...state,
        sortingFilter: payload.filter,
      };
      break;
    case 'SET_SUPPORTED_LANGUAGES':
      newState = {
        ...state,
        supportedLanguages: payload.supportedLanguages,
      };
      break;
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
  return newState;
}
